var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGong({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 268,
    viewBox: "0 0 236 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gong_svg__clip0_2286_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 118.952h-57c-3.3 0-5.7 3.3-4.6 6.4l13.7 35.5c.6 1.6-.6 3.3-2.3 3.2l-17.5-1.1c-.8-.1-1.6.3-2 1l-13.6 19.3c-.7 1.1-2.2 1.5-3.3.7l-20.2-13.7c-.8-.5-1.9-.5-2.6 0l-28 18.9c-1.8 1.2-4.2-.5-3.6-2.6l7.8-27.8c.3-1.2-.2-2.3-1.4-2.8l-14.8-6c-1.5-.6-1.9-2.4-.9-3.6l13-16.2c.6-.8.7-1.9.1-2.8l-11-15.9c-1-1.5-.1-3.5 1.8-3.6l17.1-1.3c1.2-.1 2.2-1.2 2.2-2.5l-1.4-23.9c-.1-1.7 1.6-2.9 3.3-2.3l21.2 8.8c.9.4 2 .2 2.6-.6l14.6-16.3c1.2-1.3 3.3-.9 4 .6l8.8 22.6c1.2 2.8 4.7 3.8 7.1 1.9l34.3-25.5c3.9-2.9 1.4-9.1-3.4-8.4l-22.6 3c-1.1.2-2.1-.5-2.5-1.5l-11.9-30.5c-1.3-3.2-5.4-4-7.8-1.4l-25.8 28c-.7.7-1.7.9-2.6.5l-34-14.3c-3-1.2-6.4.9-6.5 4.2l-1.2 35.1c-.1 1.2-1 2.2-2.2 2.2l-31 2c-3.6.2-5.6 4.3-3.6 7.3l20.6 30.4c.6.9.5 2-.2 2.9l-20.9 24c-2.1 2.4-1.2 6.1 1.7 7.4l24 10.4c1.1.5 1.6 1.6 1.3 2.7l-15.4 60c-1.1 4.3 3.7 7.5 7.3 5l57.7-41.4c.8-.5 1.9-.6 2.7 0l26.3 18.5c2.2 1.6 5.1.9 6.6-1.2l16.4-25.2c.5-.8 1.4-1.2 2.2-1l39.3 4.7c3.2.5 6.4-2.2 5.2-5.1l-16.4-42.3c-.5-1.2 0-2.4 1.4-3.1l29.9-14.1c4.6-2.4 3-9.2-2-9.2z",
    fill: "#8039E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gong_svg__clip0_2286_97"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h236v268H0z"
  })))));
}

export default SvgGong;